import { styled } from "@mui/material/styles";
import React from "react";

const DataLabelRoot = styled("fieldset", {
  name: "DataLabel",
  slot: "root",
})(() => ({
  display: "inline-flex",
  flexDirection: "column",
}));

const DataLabelLegend = styled("fieldset", {
  name: "DataLabel",
  slot: "label",
})(({ theme }) => ({
  fontSize: "0.6rem",
  textTransform: "uppercase",
  color: theme.palette.text.secondary,
  letterSpacing: "0.1rem",
}));

const DataLabelValue = styled("fieldset", {
  name: "DataLabel",
  slot: "value",
})(() => ({
  fontSize: "unset",
  // fontWeight: "bold",
}));

type Props = {
  label: string;
  children?: React.ReactNode;
};

const DataLabel = React.forwardRef(function DataLabel(
  props: Props,
  ref: React.Ref<HTMLFieldSetElement>
) {
  const { label, children, ...rest } = props;

  return (
    <DataLabelRoot ref={ref} {...rest}>
      <DataLabelLegend>{label}</DataLabelLegend>
      <DataLabelValue>{children}</DataLabelValue>
    </DataLabelRoot>
  );
});

export default DataLabel;
